/* JWL CART — free-shipping progress track. Rationale: docs/jwl-cart-build.md -> "JS notes" */
(function () {
  function ensureParts(el) {
    var message = el.querySelector('.jwl-shipping-message');
    if (!message) {
      message = document.createElement('div');
      message.className = 'jwl-shipping-message';
      el.insertBefore(message, el.firstChild);
    }

    /* icon + theme placeholder start as direct children; order matters — see docs */
    var icon = el.querySelector('.jwl-shipping-row__icon');
    if (icon && icon.parentElement !== message) {
      message.insertBefore(icon, message.firstChild);
    }

    var placeholder = el.querySelector('.text-subdued');
    if (placeholder && placeholder.parentElement !== message) {
      message.appendChild(placeholder);
    }

    var track = el.querySelector('.jwl-shipping-track');
    if (!track) {
      track = document.createElement('div');
      track.className = 'jwl-shipping-track';
      track.appendChild(document.createElement('span'));
      el.insertBefore(track, message.nextSibling);
    }

    /* track-end icon moved once; position is pure CSS — see docs */
    var trackIcon = el.querySelector('.jwl-shipping-track__icon');
    if (trackIcon && trackIcon.parentElement !== track) {
      track.appendChild(trackIcon);
    }

    return track;
  }

  function update(el) {
    var track = ensureParts(el);
    var fill = track.querySelector('span');
    var threshold = parseFloat(el.getAttribute('threshold')) || 0;
    var total = parseFloat(el.getAttribute('total-price')) || 0;
    var qualified = threshold > 0 && total >= threshold;
    var pct = threshold > 0 ? Math.min(100, (total / threshold) * 100) : 100;
    fill.style.width = pct + '%';
    track.classList.toggle('jwl-shipping-track--qualified', qualified);
  }

  function scan() {
    document.querySelectorAll('free-shipping-bar').forEach(update);
  }

  function start() {
    scan();
    new MutationObserver(scan).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['total-price', 'threshold'],
    });
  }

  if (document.body) {
    start();
  } else {
    document.addEventListener('DOMContentLoaded', start);
  }
})();

/* JWL CART — discount code (snippets/cart-discount.liquid). The theme applies a code on the field's change event,
   which only fires when the field is committed. "Apply" and Enter commit it by taking focus off the field, so the
   code goes through once; Enter would otherwise also submit the cart form the field sits in. Delegated, because the
   drawer replaces its contents on every cart change. */
(function () {
  var FIELD = 'cart-discount-field input.input';

  document.addEventListener('click', function (event) {
    var apply = event.target.closest && event.target.closest('.jwl-discount__apply');
    if (!apply) return;
    var input = apply.closest('cart-discount-field').querySelector(FIELD);
    if (input) input.blur();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' || !event.target.matches || !event.target.matches(FIELD)) return;
    event.preventDefault();
    event.target.blur();
  });
})();

/* JWL CART — one-tap discount button (snippets/cart-discount.liquid; theme settings -> Cart -> "Cart: one-tap discount
   button"). Adds the button's code to any codes already on the cart, the same way the theme's own field does. If the
   cart accepts it, the cart refreshes: the drawer redraws itself with the button reading "applied" and the theme's
   discount badge under it, and the /cart page reloads. If the code can't be used on this cart, it is taken off again
   so it doesn't sit there unused, and a short note shows under the button. Delegated, because the drawer replaces its
   contents on every cart change. */
(function () {
  function sameCode(a, b) {
    return String(a).toLowerCase() === String(b).toLowerCase();
  }

  function updateDiscounts(root, codes) {
    return fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') })
    });
  }

  document.addEventListener('click', async function (event) {
    var button = event.target.closest && event.target.closest('[data-jwl-quick-discount]');
    if (!button) return;
    event.preventDefault();
    if (button.getAttribute('aria-busy') === 'true') return;

    var code = button.getAttribute('data-jwl-quick-discount');
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var note = button.parentElement.querySelector('[data-jwl-quick-discount-error]');

    button.setAttribute('aria-busy', 'true');
    if (note) note.hidden = true;

    try {
      var cart = await (await fetch(root + 'cart.js')).json();
      var codes = (cart.discount_codes || [])
        .filter(function (discount) { return discount.applicable; })
        .map(function (discount) { return discount.code; });
      if (!codes.some(function (existing) { return sameCode(existing, code); })) codes.push(code);

      var response = await updateDiscounts(root, codes);
      var data = response.ok ? await response.json() : null;
      var mine = data && (data.discount_codes || []).find(function (discount) { return sameCode(discount.code, code); });

      if (mine && mine.applicable) {
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        if (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.pageType === 'cart') {
          window.location.reload();
        }
        return;
      }

      if (data) {
        await updateDiscounts(root, codes.filter(function (existing) { return !sameCode(existing, code); }));
      }
      if (note) note.hidden = false;
    } catch (error) {
      if (note) note.hidden = false;
    }

    button.setAttribute('aria-busy', 'false');
  });
})();
